module.exports = __webpack_public_path__ + "static/media/pla_roa_pla_pin.647c440b.png";